import req from './req'

// 群组-获取群组列表
export function getGroupsList (params) {
  return req.get('/groups/list', params)
}

// 群组-获取群组详情
export function getGroupsInfo (groupsId, params) {
  return req.get('/groups/info/' + groupsId, params)
}

// 群组-创建群组
export function createGroups (params) {
  return req.post('/groups/create', params)
}

// 群组-修改群组
export function updateGroups (groupsId, params) {
  return req.post('/groups/update/' + groupsId, params)
}

// 群组-删除群组
export function deleteGroups (groupsId, params) {
  return req.post('/groups/delete/' + groupsId, params)
}

// 群组-同步企微群组
export function syncWechatGroups (params) {
  return req.get('/groups/sync_wechat', params)
}

// 获取企微部门
export function getWechatDepartment (params) {
  return req.get('/workwechat/department', params)
}

// 店铺接口-获取店铺信息接口
export function getStoreList (params) {
  return req.get('/store/store', params)
}

// 店铺接口-获取店铺信息接口
export function storeBindGroup (params) {
  return req.post('/store/bind-group', params)
}
